import { isMassiveTab, matchesVinculacionFilters } from './vinculacionTabs'
import { getVinculacionMonto } from './vinculacionMonto'
import clsx from 'clsx'
import TableActionsMenu from '../TableActionsMenu'
import { esCreditoRecordatorio } from './Modales/Prestamo/prestamoRecordatorio'
import { Text } from '../../../../ui'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import StarIcon from '@mui/icons-material/StarOutlineOutlined'
import StarFullIcon from '@mui/icons-material/StarOutlined'
import ComentarioIcon from '@mui/icons-material/SpeakerNotesOutlined'
import { VinculacionIcon, getVinculacionTemplate } from './IconosPlantilla'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import AddIcon from '@mui/icons-material/AddToPhotosOutlined'
import { sileo } from 'sileo'
import businessApi from '../../../../../../api/business.api'
import { formatCurrency, formatDate, formatRut } from '../../../../../utils/formatter'
import GlobalContext from '../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../api/organization.api'
import iconoEnlace from '../../../../../../assets/iconos/iconEnlace.png'
import ModalConciliarVinculacion from './modalDialogEditVinculacion/ModalConciliarVinculacion'
import PagoArriendos from './Modales/PagoArriendos'
import CobroArriendos from './Modales/CobroArriendos'
import GastosComunes from './Modales/GastosComunes'
import RetiroDividendo from './Modales/RetiroDividendo'
import PrestamoRecibido from './Modales/Prestamo/PrestamoRecibido'
import SubTablaPrestamo from './Modales/Prestamo/SubTablaPrestamo'
import PrestamoStatus from './Modales/Prestamo/PrestamoStatus'
import DevolucionImpuestos from './Modales/DevolucionImpuestos'
import AporteTransitorioSocio from './Modales/AporteTransitorioSocio'
import PagoPatenteComercial from './Modales/PagoPatenteComercial'
import PagoContribuciones from './Modales/PagoContribuciones'
import CobroCuotaPrestamo from './Modales/CobroCuotaPrestamo'
import PagoCuotaPrestamo from './Modales/PagoCuotaPrestamo'
import DevolucionAporteTransitorio from './Modales/DevolucionAporteTransitorio'
import RendicionDeGastos from './Modales/RendicionDeGastos'
import DatosReferenciaAclarar from './Modales/DatosReferenciaAclarar'
import Invoice from './Modales/InvoiceCompra'
import InvoiceImportaciones from './Modales/InvoiceImportaciones'
import PrestamoOtorgado from './Modales/Prestamo/PrestamoOtorgado'
import { Link, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ModalViewAdministracion from '../../../../ui/tables/baseTable/ModalViewAdministracion'
import InvoiceVenta from './Modales/InvoiceVenta'
import Finiquitos from './Modales/Finiquitos'
import Inversiones from './Modales/Inversiones'
import ProvisionClientes from './Modales/ProvisionClientes'
import ProvisionProveedor from './Modales/ProvisionProveedor'
import ValoresNegociables from './Modales/ValoresNegociables'
import isologo_SII from '../../../../../../assets/isologo_SII.png'
import DesconciliarCaja from './Modales/CajaPrincipal/DesconciliarCaja'
import AjusteExistencia from './Modales/AjusteExistencias'
import VinculacionGenericaAbono from './Modales/GenericaAbono'
import VinculacionGenericaCargo from './Modales/GenericoCargo'
import { BankAPI } from '../../../../../../api/bancos.api'
import ModalComentarios from '../bancos/table/ModalComentarios'
import LinkageDocumentsIcon from './LinkageDocumentsIcon'
import AnticipoAgenteAduana from './Modales/AnticipoAgenteAduana'
import DevolucionAgenteAduana from './Modales/DevolucionAgenteAduana'
import AnticipoSueldo from './Modales/AnticipoSueldo'
import ProvisionAgenteAduana from './Modales/ProvisionAgenteAduana'
import Multas from './Modales/Multas'
import {
  AporteEmpresaRelacionada,
  DevolucionEmpresaRelacionada
} from './Modales/EmpresaRelacionada'

const isCajaPrincipalCuentaMenosUno = item => {
  const bankName = item?.bank?.name || item?.nombreCuentaBanco || item?.nombreBanco
  const numeroCuenta = item?.numeroCuenta ?? item?.numeroCuentaBanco

  return (
    String(bankName || '').trim().toLowerCase() === 'caja principal' &&
    String(numeroCuenta ?? '').trim() === '-1'
  )
}

const ACLARAR_REFERENCE_ACCOUNTS = new Set(['cargos por aclarar', 'abonos por aclarar'])

const isAclararReferenceAccount = row =>
  ACLARAR_REFERENCE_ACCOUNTS.has(String(row?.nombreCuenta || '').trim().toLowerCase())

const getCommentRowId = row => row?.id ?? row?.idPrincipal ?? null

const getDinRevDocumentId = row =>
  row?.idPrincipal ??
  row?.id ??
  row?.libro?.idPrincipal ??
  row?.libro?.id ??
  row?.din?.idPrincipal ??
  row?.din?.id

const MASSIVE_LINKAGE_TYPE_BY_MOVEMENT_TYPE = {
  cargo: 'pago-masivo',
  abono: 'cobro-masivo'
}

const MASSIVE_LINKAGE_TYPE_VALUES = new Set(Object.values(MASSIVE_LINKAGE_TYPE_BY_MOVEMENT_TYPE))

const TableVinculaciones = ({
  row,
  rowsPerPage,
  setRowsPerPage,
  onSort,
  order,
  getData,
  setSwitchGetData,
  highlightedRows,
  toggleHighlight,
  massivePeriodTrace,
  yearFilter,
  monthFilter,
  onMassiveTypesChange,
  linkageTypeFilter,
  centroCostoFilter,
  movementTab,
  massivePage = 0,
  onMassiveRowsChange,
  searchFilters,
  statusFilter
}) => {
  const [page] = useState(0)
  const [modalType, setModalType] = useState(null)
  const [modalAction, setModalAction] = useState(null)
  const [open, setOpen] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [prestamosExpandidos, setPrestamosExpandidos] = useState({})
  const renderFlechaPrestamo = row => [4, 6].includes(Number(row.folioCredito)) && (
    <button type='button' aria-label='Mostrar cuotas del préstamo' aria-expanded={!!prestamosExpandidos[row.id]}
      className='rounded bg-gray-200 p-0.5'
      onClick={() => setPrestamosExpandidos(prev => ({ ...prev, [row.id]: !prev[row.id] }))}>
      <KeyboardArrowDownIcon fontSize='small' className={prestamosExpandidos[row.id] ? 'rotate-180' : ''} />
    </button>
  )
  const [commentModal, setCommentModal] = useState({
    open: false,
    rowId: null
  })
  const [commentsByRow, setCommentsByRow] = useState({})
  const { currentBusiness } = useContext(GlobalContext)
  const [switchDate, setSwitchDate] = useState(false)
  const organizationAPI = new OrganizationAPI()
  const [, setData] = useState([])
  const [dataBanco, setDataBanco] = useState([])
  const [openComprobante, setOpenComprobante] = useState(false)
  const [deletingKey, setDeletingKey] = useState(null)
  const [cajaMasiva] = useState({})
  const today = new Date()
  const yearNum = today.getFullYear()
  const [tipoMovimientoSeleccionado] = useState(null)
  const bankAPI = new BankAPI()
  const [movimientosMasivos, setMovimientosMasivos] = useState([])
  const [filasMasivas, setFilasMasivas] = useState([])
  const [dataModal, setDataModal] = useState({
    idLibro: '',
    fVenc: '',
    folio: '',
    status: '',
    folioCredito: '',
    nombreOrigen: '',
    provisionMode: 'registro',
    dinRevData: null,
    dinRevDocuments: []
  })
  const [dataComprobante, setDataComprobante] = useState({
    libroId: '',
    nombreFolio: '',
    folio: ''
  })
  const [openCaja, setOpenCaja] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const getVinculoDeleteKey = item => `vinculo-${item?.idPrincipal ?? item?.id}`
  const getDinRevDeleteKey = item => `din-rev-${item?.idPrincipal ?? item?.id}`
  const getMassiveDeleteKey = item =>
    `masivo-${item?.id ?? item?.query ?? item?.fecha ?? ''}`

  const rowCommentsById = useMemo(() => {
    const mappedComments = {}

    if (!Array.isArray(row)) return mappedComments

    row.forEach(item => {
      const rowId = getCommentRowId(item)
      if (rowId == null) return

      const commentValue = item?.comentario ?? item?.comment
      if (commentValue == null) return

      mappedComments[rowId] = String(commentValue)
    })

    return mappedComments
  }, [row])

  const handleOpenComments = rowId => {
    if (rowId == null) return

    setCommentModal({
      open: true,
      rowId
    })
  }

  const handleCloseComments = () => {
    setCommentModal({
      open: false,
      rowId: null
    })
  }

  const getCommentValue = rowId => {
    if (rowId == null) return ''

    if (Object.prototype.hasOwnProperty.call(commentsByRow, rowId)) {
      return commentsByRow[rowId] || ''
    }

    return rowCommentsById[rowId] || ''
  }

  const hasComment = rowId => Boolean(getCommentValue(rowId).trim())

  const handleSaveComment = async comment => {
    if (!currentBusiness?.id || commentModal.rowId == null) {
      sileo.error({
        title: 'Error al guardar',
        description: 'No se pudo identificar el movimiento para guardar el comentario.'
      })
      return
    }

    const normalizedComment = String(comment || '')

    await sileo.promise(
      businessApi.postComentarioMovimiento(currentBusiness.id, commentModal.rowId, normalizedComment),
      {
        loading: { title: 'Guardando comentario' },
        success: {
          title: 'Comentario guardado',
          description: (
            <span className='text-green-500/80 font-medium'>
              El comentario del movimiento se guardo correctamente.
            </span>
          )
        },
        error: {
          title: 'Error al guardar',
          description: 'No se pudo guardar el comentario del movimiento.'
        }
      }
    )

    setCommentsByRow(prev => ({
      ...prev,
      [commentModal.rowId]: normalizedComment
    }))

    handleCloseComments()
    setSwitchGetData(true)
  }

  useEffect(() => {
    if (!Array.isArray(massivePeriodTrace) || massivePeriodTrace.length === 0) return
  }, [massivePeriodTrace])

  const handleComprobante = (libroId, nombreFolio, folio) => {
    setDataComprobante({ libroId, nombreFolio, folio })
    setOpenComprobante(true)
  }
  /*const handleCaja = tipo => {
    setOpenCaja(true)
    setTipoMovimientoSeleccionado(tipo)
  }*/

  const mapFolioToModal = {
    0: 'Pago Arriendos',
    1: 'Cobro Arriendos',
    2: 'Gastos Comunes',
    3: 'Retiro Dividendo',
    4: 'Prestamo Otorgado',
    5: 'Cobro Cuota Prestamo',
    6: 'Credito Consumo',
    7: 'Pago Cuota Prestamo',
    8: 'Pago Patente Comercial',
    9: 'Pago Contribuciones',
    10: 'Aporte Transitorio Socio',
    11: 'Devolucion Aporte Transitorio',
    12: 'Rendicion Gastos',
    13: 'Invoice Compra',
    35: 'Invoice Importaciones',
    36: 'Devolución de Impuestos',
    14: 'Invoice Venta',
    15: 'Finiquitos',
    16: 'Inversiones dap',
    17: 'Inversiones ffmm',
    18: 'Inversiones otras',
    19: 'Acciones en bolsa',
    20: 'Criptomonedas',
    21: 'Otros valores negociables',
    22: 'Ajuste Existencias',
    23: 'Pago año anterior',
    24: 'Cobro año anterior',
    25: 'Vinculación Generica Cargo',
    26: 'Vinculación Generica Abono',
    27: 'Anticipo Agente Aduana',
    28: 'Anticipo Sueldo',
    29: 'Multas',
    30: 'Devolución Agente Aduana',
    33: 'Aporte Empresa Relacionada',
    34: 'Devolución Empresa Relacionada',
    31: 'Previred año anterior',
    32: 'Remuneración año anterior'
  }

  const handleClickOpen = (row, actionType) => {
    if (Number(row.folioCredito) === 35 && actionType === 'replicar') return
    const egresos = [24, 25]
    const ingresos = [26, 27]
    let type = 'vinculos'

    if (egresos.includes(row.origenTabla)) {
      type = 'egreso'
    } else if (ingresos.includes(row.origenTabla)) {
      type = 'ingreso'
    }

    setDataModal({
      idLibro: row.id,
      idOrigin: row.idOrigin,
      fVenc: row.fechaVencimiento,
      folio: row.numeroFolio,
      type,
      folioCredito: row.folioCredito,
      nombreOrigen: row.nombreOrigen,
      origenTabla: row.origenTabla
    })

    const mapFolioToModal = {
      0: 'PagoArriendos',
      1: 'CobroArriendos',
      2: 'GastosComunes',
      3: 'RetiroDividendo',
      4: 'PrestamoOtorgado',
      5: 'CobroCuotaPrestamo',
      6: 'PrestamoRecibido',
      7: 'PagoCuotaPrestamo',
      8: 'PagoPatenteComercial',
      9: 'PagoContribuciones',
      10: 'AporteTransitorioSocio',
      36: 'DevolucionImpuestos',
      11: 'DevolucionAporteTransitorio',
      12: 'RendicionDeGastos',
      13: 'InvoiceCompra',
      35: 'InvoiceImportaciones',
      14: 'InvoiceVenta',
      15: 'Finiquitos',
      16: 'InversionesDap',
      17: 'InversionesFfmm',
      18: 'InversionesOtras',
      19: 'AccionesEnBolsa',
      20: 'Criptomonedas',
      21: 'OtrosValoresNegociables',
      22: 'AjusteExistencia',
      25: 'VinculacionGenericaCargo',
      26: 'VinculacionGenericaAbono',
      27: 'AnticipoAgenteAduana',
      28: 'AnticipoSueldo',
      29: 'Multas',
      30: 'DevolucionAgenteAduana',
      33: 'AporteEmpresaRelacionada',
      34: 'DevolucionEmpresaRelacionada'
    }

    let modalType = mapFolioToModal[row.folioCredito] || 'default'
    if (
      actionType === 'modificar' &&
      Number(row.folioCredito) === 24 &&
      isAclararReferenceAccount(row)
    ) {
      modalType = 'DatosReferenciaAclarar'
    } else if (Number(row.folioCredito) === 24) {
      modalType = type === 'ingreso' ? 'ProvisionClientes' : 'ProvisionProveedor'
    } else if ([16, 17, 18].includes(Number(row.folioCredito))) {
      modalType = 'Inversiones'
    } else if ([19, 20, 21].includes(Number(row.folioCredito))) {
      modalType = 'AccionesNegociables'
    }

    setModalType(modalType)
    setModalAction(actionType)
    setOpen(true)
  }

  const getBanco = async () => {
    try {
      if (!currentBusiness?.id) {
        setDataBanco([])
        return
      }
      const responseBank = await bankAPI.getListBank(currentBusiness.id)
      const bankList = Array.isArray(responseBank?.data)
        ? responseBank.data
        : Array.isArray(responseBank?.data?.data)
          ? responseBank.data.data
          : []

      setDataBanco(bankList)
    } catch (error) {
      console.error(error)
      setDataBanco([])
    }
  }

  const getMasivaRelatedIds = mov => {
    const auxiliaryIds = Array.isArray(mov?.auxiliar)
      ? mov.auxiliar.flatMap(aux => [aux?.idPrincipal, aux?.id])
      : []
    const linkageIds = Array.isArray(mov?.linkage)
      ? mov.linkage.flatMap(link => [link?.idPrincipal, link?.id])
      : []

    const rawIds = auxiliaryIds.length > 0
      ? auxiliaryIds
      : linkageIds.length > 0
        ? linkageIds
        : [mov?.idPrincipal, mov?.id]

    return [...new Set(rawIds.map(Number).filter(Number.isFinite))]
  }

  const getCajaMasiva = async () => {
    try {
      if (!currentBusiness?.id) {
        setFilasMasivas([])
        return
      }

      const cajaPrincipal = dataBanco?.find(isCajaPrincipalCuentaMenosUno)
      const idCajaPrincipal = cajaPrincipal?.id
      if (!idCajaPrincipal) {
        console.warn('[TableVinculaciones] No se encontro Caja Principal con numeroCuenta -1 en bank-account')
        setFilasMasivas([])
        return
      }

      const response = await organizationAPI.getMasivaCaja(
        currentBusiness.id,
        idCajaPrincipal,
        Number(monthFilter) || 0,
        Number(yearFilter) || yearNum,
        1000
      )

      const movimientos = response.data || []
      setMovimientosMasivos(Array.isArray(movimientos) ? movimientos : [])
    } catch (error) {
      console.error(error)
      setMovimientosMasivos([])
    }
  }

  useEffect(() => {
    if (!currentBusiness?.id) {
      setDataBanco([])
      setMovimientosMasivos([])
      setFilasMasivas([])
      return
    }

    getData()
    getBanco()
    if (switchDate) {
      setSwitchGetData?.(true)
    }
    setSwitchDate(false)
  }, [currentBusiness?.id, switchDate])

  useEffect(() => {
    if (!currentBusiness?.id || dataBanco?.length === 0) return
    getCajaMasiva()
  }, [currentBusiness?.id, dataBanco, monthFilter, yearFilter])

  useEffect(() => {
    if (!Array.isArray(movimientosMasivos) || movimientosMasivos.length === 0) {
      setFilasMasivas([])
      return
    }

    setFilasMasivas(groupByTipoYFecha(movimientosMasivos))
  }, [movimientosMasivos, massivePeriodTrace])

  const handleCajaDesvincular = async filaMasiva => {
    const deleteKey = getMassiveDeleteKey(filaMasiva)
    if (deletingKey != null) return

    try {
      const ids = filaMasiva.movimientos
        .flatMap(getMasivaRelatedIds)

      if (!ids.length) return

      setDeletingKey(deleteKey)
      const body = { ids: [...new Set(ids)] }

      await organizationAPI.postCajaMultipleDes({ businessId: currentBusiness.id }, body)

      setSwitchDate(true)
    } catch (error) {
      console.error(error)
    } finally {
      setDeletingKey(null)
    }
  }

  const commonModalProps = {
    open,
    setOpen,
    idLibro: dataModal.idLibro,
    idOrigin: dataModal.idOrigin,
    fVenc: dataModal.fVenc,
    folio: dataModal.folio,
    type: dataModal.type,
    provisionMode: dataModal.provisionMode,
    dinRevData: dataModal.dinRevData,
    dinRevDocuments: dataModal.dinRevDocuments,
    setSwitchDate: setSwitchDate
  }

  const handleClickEdit = row => {
    if (esCreditoRecordatorio(row)) return
    if (Number(row.folioCredito) === 6 && !row.cuotaPrestamo) return
    if (row?._isDinRevVirtual) {
      setDataModal(current => ({
        ...current,
        provisionMode: 'conciliar-din-rev',
        dinRevData: row._dinRevResponseData,
        dinRevDocuments: row._dinRevDocuments || []
      }))
      setModalType('ProvisionAgenteAduana')
      setModalAction('editar')
      setOpen(true)
      return
    }

    const egresos = [24, 25]
    const ingresos = [26, 27]

    let type = 'vinculos' // valor por defecto

    if (egresos.includes(row.origenTabla)) {
      type = 'egreso'
    } else if (ingresos.includes(row.origenTabla)) {
      type = 'ingreso'
    }

    setDataModal({
      idLibro: row.id,
      idOrigin: row.idOrigin,
      fVenc: row.fechaVencimiento,
      folio: row.numeroFolio,
      status: row.status,
      cuotaPrestamo: row.cuotaPrestamo,
      type,
      folioCredito: row.folioCredito,
      nombreOrigen: row.nombreOrigen,
      origenTabla: row.origenTabla
    })
    setOpenEdit(true)
  }

  const filteredRows = isMassiveTab(movementTab) || MASSIVE_LINKAGE_TYPE_VALUES.has(linkageTypeFilter)
    ? []
    : Object.values(
      row.reduce((acc, item, index) => {
      const id = item.idPrincipal ?? item.id ?? `row-${index}`

      // Si no existe aún, lo agregamos
      if (!acc[id]) {
        acc[id] = item
      } else {
        // Si ya existe uno con el mismo idPrincipal, comparamos los montos
        const existing = acc[id]
        const existingMonto = Math.max(existing.debe ?? 0, existing.haber ?? 0)
        const currentMonto = Math.max(item.debe ?? 0, item.haber ?? 0)

        if (currentMonto > existingMonto) {
          acc[id] = item // reemplazamos si el nuevo tiene monto mayor
        }
      }

      return acc
      }, {})
    )

  const styles = {
    table: 'w-full min-w-[1180px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[70px] sm:max-w-[80px]',
    wideCol: 'w-auto max-w-[220px] sm:max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-400 font-medium',
    dateHeader: 'bg-gray-50/80 backdrop-blur-sm border-y border-gray-200/50 py-2 px-4 text-left font-bold text-primary flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-colors group font-sans'
  }

  const normalizeStatus = status =>
    String(status || '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/_/g, ' ')
      .trim()

  const getStatusKey = status => {
    const normalized = normalizeStatus(status)
    if (!normalized) return 'UNKNOWN'
    if (normalized.includes('PARCIAL')) {
      if (normalized.includes('PAG')) return 'PARCIAL_PAGADO'
      if (normalized.includes('COBR')) return 'PARCIAL_COBRADO'
    }
    if (normalized.includes('POR PAG')) return 'POR_PAGAR'
    if (normalized.includes('POR COB')) return 'POR_COBRAR'
    if (normalized.includes('PAGADO')) return 'PAGADO'
    if (normalized.includes('COBRADO')) return 'COBRADO'
    if (normalized.includes('CONCILIADO')) return 'CONCILIADO'
    return normalized
  }

  const getStatusLabel = status => {
    const key = getStatusKey(status)
    if (key === 'PARCIAL_PAGADO') return 'PARCIALMENTE PAGADO'
    if (key === 'PARCIAL_COBRADO') return 'PARCIALMENTE COBRADO'
    if (key === 'POR_PAGAR') return 'POR PAGAR'
    if (key === 'POR_COBRAR') return 'POR COBRAR'
    if (key === 'PAGADO') return 'PAGADO'
    if (key === 'COBRADO') return 'COBRADO'
    if (key === 'CONCILIADO') return 'CONCILIADO'
    return key === 'UNKNOWN' ? '—' : key
  }

  const getRowStatusLabel = row => {
    const label = getStatusLabel(row?.status)
    return row?._isDinRevVirtual && label === 'PAGADO' ? 'PAGADA' : label
  }

  const statusBadgeClass = status => {
    const key = getStatusKey(status)
    const isPending = key === 'POR_PAGAR' || key === 'POR_COBRAR'
    const isPaid = key === 'PAGADO' || key === 'COBRADO' || key === 'CONCILIADO'
    const isPartial = key === 'PARCIAL_PAGADO' || key === 'PARCIAL_COBRADO'
    return clsx(
      'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.55rem] sm:text-[0.6rem] font-semibold uppercase tracking-wider leading-tight',
      {
        'text-danger bg-danger/10': isPending,
        'text-success bg-success/10': isPaid,
        'text-amber-700 bg-amber-100': isPartial,
        'text-muted bg-border/40': !isPending && !isPaid && !isPartial
      }
    )
  }

  const getCentroCostoValue = row =>
    row?.centroCosto ?? row?.centroCostos ?? row?.centro ?? row?.centrosCosto ?? null

  const hasCentroCostoAssignment = centroCosto => {
    if (Array.isArray(centroCosto)) {
      return centroCosto.some(item => {
        if (item == null) return false
        if (typeof item === 'object') return Object.keys(item).length > 0
        return String(item).trim() !== ''
      })
    }

    if (centroCosto && typeof centroCosto === 'object') {
      return Object.keys(centroCosto).length > 0
    }

    if (typeof centroCosto === 'string') {
      const normalized = centroCosto.trim()
      return normalized !== '' && normalized !== '-' && normalized !== '[]'
    }

    return Boolean(centroCosto)
  }

  const rowHasCentroCosto = row => {
    if (hasCentroCostoAssignment(getCentroCostoValue(row))) return true

    const relatedRows = [row?.auxiliar, row?.linkage, row?.movimientos].flatMap(value => {
      if (Array.isArray(value)) return value
      return value ? [value] : []
    })

    return relatedRows.some(item => {
      if (hasCentroCostoAssignment(getCentroCostoValue(item))) return true

      const nestedRows = [item?.auxiliar, item?.linkage].flatMap(value => {
        if (Array.isArray(value)) return value
        return value ? [value] : []
      })

      return nestedRows.some(nestedItem => hasCentroCostoAssignment(getCentroCostoValue(nestedItem)))
    })
  }

  const centroCostoBadgeClass = hasCentroCosto =>
    clsx(
      'inline-flex items-center justify-center min-w-[3.25rem] px-3 py-1 rounded-full text-[0.55rem] sm:text-[0.6rem] font-semibold tracking-wider leading-tight',
      {
        'text-accent2 bg-accent2/10': hasCentroCosto,
        'text-danger bg-danger/10': !hasCentroCosto
      }
    )

  const renderCentroCostoBadge = hasCentroCosto => (
    <span className={centroCostoBadgeClass(hasCentroCosto)}>
      {hasCentroCosto ? 'ASIGNADO' : 'NO ASIGNADO'}
    </span>
  )

  const renderOriginIcon = row => {
    if (getVinculacionTemplate(row) || row.nombreOrigen === 'manual') {
      return <VinculacionIcon item={row} />
    }
    if (row.nombreOrigen === 'sii') {
      return <img src={isologo_SII} alt='sii' className='h-6 w-auto rounded' />
    }
    return <VinculacionIcon item={row} />
  }

  const formatMonthYearLabel = dateValue => {
    const date = new Date(dateValue)
    if (Number.isNaN(date.getTime())) return ''

    const label = new Intl.DateTimeFormat('es-CL', {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    }).format(date)

    return label.charAt(0).toUpperCase() + label.slice(1)
  }

  const getUTCDateKey = rawDate => {
    const date = new Date(rawDate)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().split('T')[0]
  }

  const normalizeMovementType = value => String(value || '').trim().toLowerCase()

  const getMassivePeriodLabel = mov => {
    const linkedRows = [
      ...(Array.isArray(mov?.auxiliar) ? mov.auxiliar : []),
      ...(Array.isArray(mov?.linkage) ? mov.linkage : mov?.linkage ? [mov.linkage] : [])
    ]

    const periodEntries = Array.from(
      new Map(
        linkedRows
          .map(item => item?.fecha || item?.fechaEmision || item?.createAt || item?.fechaVencimiento)
          .map(rawDate => {
            const date = new Date(rawDate)
            if (Number.isNaN(date.getTime())) return null

            const key = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`
            return [key, date]
          })
          .filter(Boolean)
      ).values()
    )

    if (periodEntries.length === 1) {
      return formatMonthYearLabel(periodEntries[0])
    }

    if (periodEntries.length > 1) {
      return 'Varios meses'
    }

    return formatMonthYearLabel(mov?.fecha)
  }

  const getTraceRelatedIds = trace => {
    if (!trace) return []

    const rawIds = [
      ...(Array.isArray(trace?.relatedIds) ? trace.relatedIds : []),
      ...(Array.isArray(trace?.selectedIds) ? trace.selectedIds : []),
      ...(Array.isArray(trace?.documents)
        ? trace.documents.flatMap(item => [item?.id, item?.idPrincipal])
        : [])
    ]

    return [...new Set(rawIds.map(Number).filter(Number.isFinite))]
  }

  const getTraceSelectedIds = trace =>
    [...new Set((Array.isArray(trace?.selectedIds) ? trace.selectedIds : []).map(Number).filter(Number.isFinite))]

  const formatTracePeriodLabel = trace => {
    const detectedPeriods = getNormalizedDetectedPeriods(trace)
    if (detectedPeriods.length === 1) return detectedPeriods[0]
    if (detectedPeriods.length > 1) return 'Varios meses'

    const monthLabel = String(trace?.filterContext?.monthLabel || '').trim()
    const yearLabel = Number(trace?.filterContext?.yearFilter || 0)

    if (!monthLabel || monthLabel.toLowerCase() === 'todos') {
      return yearLabel ? `Todos ${yearLabel}` : ''
    }

    const normalizedMonth = monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1)
    return yearLabel ? `${normalizedMonth} ${yearLabel}` : normalizedMonth
  }

  const getNormalizedDetectedPeriods = trace =>
    [...new Set(
      (Array.isArray(trace?.detectedPeriods) ? trace.detectedPeriods : [])
        .map(period => String(period || '').trim())
        .filter(Boolean)
    )]

  const getBestSameDayTrace = (candidates, targetAmount) => {
    if (!Array.isArray(candidates) || candidates.length === 0) return null
    if (candidates.length === 1) return candidates[0]

    const normalizedTargetAmount = Number(targetAmount || 0)
    const rankedCandidates = candidates
      .map(candidate => {
        const traceAmount = Number(candidate?.trace?.movementAmount || 0)
        const hasComparableAmount = normalizedTargetAmount > 0 && traceAmount > 0
        const amountDiff = hasComparableAmount
          ? Math.abs(traceAmount - normalizedTargetAmount)
          : Number.POSITIVE_INFINITY
        const createdAtTime = new Date(candidate?.trace?.createdAt || 0).getTime()

        return {
          candidate,
          hasComparableAmount,
          amountDiff,
          createdAtTime
        }
      })
      .sort((left, right) => {
        if (left.hasComparableAmount !== right.hasComparableAmount) {
          return left.hasComparableAmount ? -1 : 1
        }

        if (left.amountDiff !== right.amountDiff) {
          return left.amountDiff - right.amountDiff
        }

        return right.createdAtTime - left.createdAtTime
      })

    return rankedCandidates[0]?.candidate || null
  }

  const getDetectedPeriodsByGroup = ({
    relatedIds,
    tipoMovimiento,
    fecha,
    montoTotal,
    usedTraceIndexes = new Set()
  }) => {
    if (!Array.isArray(massivePeriodTrace) || massivePeriodTrace.length === 0) return null

    const normalizedIds = [...new Set(relatedIds.map(Number).filter(Number.isFinite))]
    const normalizedType = normalizeMovementType(tipoMovimiento)
    const expectedSourceByType = {
      cargo: 'pago-masivo',
      abono: 'cobro-masivo'
    }
    const expectedSource = expectedSourceByType[normalizedType]
    const candidateTraces = massivePeriodTrace
      .map((trace, index) => ({ trace, index }))
      .filter(({ trace, index }) =>
        !usedTraceIndexes.has(index) && (expectedSource ? trace?.source === expectedSource : true)
      )

    if (candidateTraces.length === 0) return null

    const normalizedAmount = Number(montoTotal || 0)
    const normalizedDateKey = getUTCDateKey(fecha)

    const exactMatch = candidateTraces.find(trace => {
      const selectedIds = getTraceSelectedIds(trace.trace)
      if (selectedIds.length > 0 && normalizedIds.length > 0) {
        return selectedIds.every(id => normalizedIds.includes(id))
      }

      const traceAmount = Number(trace.trace?.movementAmount || 0)
      const traceDateKey = getUTCDateKey(trace.trace?.movementDate)

      return (
        normalizedAmount > 0 &&
        traceAmount > 0 &&
        traceAmount === normalizedAmount &&
        normalizedDateKey &&
        traceDateKey === normalizedDateKey
      )
    })

    if (exactMatch) {
      usedTraceIndexes.add(exactMatch.index)
      return formatTracePeriodLabel(exactMatch.trace)
    }

    const amountAndDateMatch = candidateTraces.find(trace => {
      const traceAmount = Number(trace.trace?.movementAmount || 0)
      const traceDateKey = getUTCDateKey(trace.trace?.movementDate)

      return (
        normalizedAmount > 0 &&
        traceAmount > 0 &&
        traceAmount === normalizedAmount &&
        normalizedDateKey &&
        traceDateKey === normalizedDateKey
      )
    })

    if (amountAndDateMatch) {
      usedTraceIndexes.add(amountAndDateMatch.index)
      return formatTracePeriodLabel(amountAndDateMatch.trace)
    }

    const sameDayTraces = candidateTraces.filter(trace => {
      const traceCreatedDateKey = getUTCDateKey(trace.trace?.createdAt)
      const traceMovementDateKey = getUTCDateKey(trace.trace?.movementDate)

      return (
        normalizedDateKey &&
        (traceCreatedDateKey === normalizedDateKey || traceMovementDateKey === normalizedDateKey)
      )
    })

    const bestSameDayTrace = getBestSameDayTrace(sameDayTraces, normalizedAmount)
    if (bestSameDayTrace) {
      usedTraceIndexes.add(bestSameDayTrace.index)
      return formatTracePeriodLabel(bestSameDayTrace.trace)
    }

    const bestOverlap = candidateTraces
      .map(trace => {
        const selectedIds = getTraceSelectedIds(trace.trace)
        const comparableIds = selectedIds.length > 0 ? selectedIds : getTraceRelatedIds(trace.trace)
        const overlapCount = comparableIds.filter(id => normalizedIds.includes(id)).length

        return { trace, overlapCount }
      })
      .filter(item => item.overlapCount > 0)
      .sort((left, right) => right.overlapCount - left.overlapCount)[0]?.trace

    if (bestOverlap) {
      usedTraceIndexes.add(bestOverlap.index)
      return formatTracePeriodLabel(bestOverlap.trace)
    }

    return null
  }

  const getDisplayPeriodLabel = detectedPeriods =>
    detectedPeriods ? `Periodo: ${detectedPeriods}` : 'Periodo: No detectado'

  const renderCommentAction = ({ rowId, showLabel = true, sizeClass = 'w-8 h-8' }) => {
    const active = hasComment(rowId)

    return (
      <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
        <button
          type='button'
          className={clsx(
            'flex shadow-full-xs rounded-full items-center justify-center hover:bg-slate-100/50 transition-colors duration-150',
            sizeClass,
            {
              'bg-accent2 text-white': active,
              'bg-[#fff] text-slate-400': !active
            }
          )}
          onClick={() => handleOpenComments(rowId)}
          aria-label='Comentarios'
        >
          <ComentarioIcon className='w-5 h-5' />
        </button>
        {showLabel && <Text className='mt-2'>Comentarios</Text>}
      </div>
    )
  }

  const renderMassiveCard = (row, idx) => (
    <div key={`masiva-card-${idx}`} className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
      <div className='flex items-start justify-between gap-2'>
        <div className='flex items-start gap-2'>
          {highlightedRows[row.id] ? (
            <StarFullIcon
              style={{ color: '#FFD700', cursor: 'pointer' }}
              onClick={() => toggleHighlight(row.id)}
            />
          ) : (
            <StarIcon
              style={{ color: '#a1a1aa', cursor: 'pointer' }}
              onClick={() => toggleHighlight(row.id)}
            />
          )}
          {renderOriginIcon(row)}
          <div>
            <Text className='text-xs font-bold'>{formatDate(row.fecha)}</Text>
            <Text className='text-[11px] text-gray-500'>{row.razonSocial}</Text>
            <Text className='inline-flex mt-1 rounded-full px-2 py-0.5 text-[11px] font-semibold'>
              {getDisplayPeriodLabel(row.detectedPeriods)}
            </Text>
          </div>
        </div>
        {[4, 6].includes(Number(row.folioCredito)) ? <PrestamoStatus row={row} /> : <Text className={statusBadgeClass(row.status)}>{getRowStatusLabel(row)}</Text>}
      </div>

      <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
        <div>
          <Text className='text-[10px] text-gray-400'>Contraparte</Text>
          <Text className='text-xs font-semibold'>{row.contraparte}</Text>
        </div>
        <div>
          <Text className='text-[10px] text-gray-400'>Centro Costo</Text>
          <Text className='text-xs font-semibold text-muted'>-</Text>
        </div>
        <div className='text-right'>
          <Text className='text-[10px] text-gray-400'>Monto</Text>
          <Text className='text-sm font-bold'>{formatCurrency(getVinculacionMonto(row))}</Text>
        </div>
      </div>

      <div className='mt-3 flex items-center justify-between'>
        <button
          type='button'
          disabled={deletingKey != null}
          className='flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 disabled:cursor-wait disabled:opacity-60'
          onClick={() => handleCajaDesvincular(row)}
          aria-label='Eliminar'
        >
          {deletingKey === getMassiveDeleteKey(row) ? (
            <span className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
          ) : (
            <HighlightOffIcon sx={{ color: 'inherit', fontSize: 18 }} />
          )}
        </button>
        <Text className='text-[11px] text-gray-500'>
          {deletingKey === getMassiveDeleteKey(row) ? 'Eliminando...' : 'Eliminar'}
        </Text>
      </div>
    </div>
  )

  const renderRowCard = (row, idx) => {
    const isFormulario = row.origenTabla === 37
    const isDinRevVirtual = row?._isDinRevVirtual === true
    const tipoLabel = isDinRevVirtual
      ? 'Cuenta Corriente Agente de Aduana'
      : isFormulario
      ? 'Formulario 29'
      : mapFolioToModal[row.folioCredito] || ''
    const contraparteLabel = isFormulario
      ? 'Servicio de Impuestos Internos'
      : row.razonSocial || '<Razon Social>'
    return (
      <div key={row.id ?? idx} className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            {highlightedRows[row.id] ? (
              <StarFullIcon
                style={{ color: '#FFD700', cursor: 'pointer' }}
                onClick={() => toggleHighlight(row.id)}
              />
            ) : (
              <StarIcon
                style={{ color: '#a1a1aa', cursor: 'pointer' }}
                onClick={() => toggleHighlight(row.id)}
              />
            )}
            {renderOriginIcon(row)}
            <div>
              <Text className='text-xs font-bold'>{formatDate(row.fecha)}</Text>
              <Text className='text-[11px] text-gray-500'>{tipoLabel}</Text>
              {renderFlechaPrestamo(row)}
            </div>
          </div>
          {[4, 6].includes(Number(row.folioCredito)) ? <PrestamoStatus row={row} /> : <Text className={statusBadgeClass(row.status)}>{getRowStatusLabel(row)}</Text>}
        </div>

        {!isDinRevVirtual && (
          <div className='mt-2'>
            <Text className='text-[10px] text-gray-400'>Contraparte</Text>
            <Text className='text-xs font-semibold'>{contraparteLabel}</Text>
            {!isFormulario && (
              <Text className='text-[11px] text-gray-500'>
                {(row.rut && formatRut(row.rut)) || ''}
              </Text>
            )}
          </div>
        )}

        {!isDinRevVirtual && <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Clasificación</Text>
          {!isFormulario && (
            <div className='flex items-center justify-between gap-2'>
              <div>
                <Text className='text-xs font-semibold'>{row.nombreCuenta}</Text>
                <Text className='text-[11px] text-gray-500'>{row.codigoCuenta}</Text>
              </div>
              {!isDinRevVirtual && (
                <button
                  type='button'
                  className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
                  onClick={() => handleClickOpen(row, 'modificar')}
                  aria-label='Editar clasificación'
                >
                  <EditOutlinedIcon sx={{ color: 'inherit', fontSize: 16 }} />
                </button>
              )}
            </div>
          )}
          <Text className='text-[11px] text-gray-500'>
            {!(Number(row.folioCredito) === 6 && Number(row.comprobante) < 0) && <Link
              onClick={() => handleComprobante(row.id, row.nombreFolio, row.folio, 'vinculos')}
              style={{ cursor: 'pointer' }}
            >
              {row.comprobante}
            </Link>}
            {' @' + (row.usuarioClasificador || 'TryLuca')}
          </Text>
        </div>}

        {!isDinRevVirtual && <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Centro Costo</Text>
          {renderCentroCostoBadge(rowHasCentroCosto(row))}
        </div>}

        <div className={clsx('mt-2 grid gap-2 text-xs', isDinRevVirtual ? 'grid-cols-1' : 'grid-cols-2')}>
          {!isDinRevVirtual && <div>
            <Text className='text-[10px] text-gray-400'>Folio</Text>
            <Text className='text-xs font-semibold'>Folio <LinkageDocumentsIcon row={row} businessId={currentBusiness?.id}>{row.numeroFolio ?? '-'}</LinkageDocumentsIcon></Text>
          </div>}
          <div className='text-right'>
            <Text className='text-[10px] text-gray-400'>Monto</Text>
            <Text className='text-sm font-bold'>{formatCurrency(getVinculacionMonto(row))}</Text>
          </div>
        </div>

        <div className='mt-3 flex items-center justify-between'>
          {!(Number(row.folioCredito) === 6 && !row.cuotaPrestamo) && <div className='flex items-center gap-2'>
            <button
              type='button'
              className={clsx(
                'flex items-center justify-center w-9 h-9 rounded-full shadow-full-xs',
                {
                  'bg-accent2 text-white': row.status === 'PAGADO' || row.status === 'COBRADO',
                  'bg-white text-slate-400': row.status !== 'PAGADO' && row.status !== 'COBRADO'
                }
              )}
              onClick={() => handleClickEdit(row)}
              aria-label='Conciliar'
            >
              <img
                src={iconoEnlace}
                alt='icono enlace'
                className={clsx('w-5 h-5', {
                  'brightness-200': row.status === 'PAGADO' || row.status === 'COBRADO'
                })}
              />
            </button>
            <Text className='text-[11px] text-gray-500'>
              {row.status === 'PAGADO' || row.status === 'COBRADO' ? 'Conciliado' : 'Conciliar'}
            </Text>
          </div>}
          {!isFormulario && !isDinRevVirtual && (
            <div className='flex items-center gap-3'>
              {renderCommentAction({
                rowId: getCommentRowId(row),
                showLabel: false,
                sizeClass: 'w-9 h-9'
              })}
              <button
                type='button'
                className='flex items-center justify-center w-9 h-9 rounded-full bg-gray-100'
                onClick={() => handleClickOpen(row, 'replicar')}
                style={Number(row.folioCredito) === 35 ? { display: 'none' } : undefined}
                aria-label='Replicar'
              >
                <AddIcon sx={{ color: 'inherit', fontSize: 18 }} />
              </button>
              <button
                type='button'
                disabled={deletingKey != null}
                className='flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 disabled:cursor-wait disabled:opacity-60'
                onClick={() => handleDelete(row)}
                aria-label='Eliminar'
              >
                {deletingKey === getVinculoDeleteKey(row) ? (
                  <span className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
                ) : (
                  <HighlightOffIcon sx={{ color: 'inherit', fontSize: 18 }} />
                )}
              </button>
            </div>
          )}
          {isDinRevVirtual && (
            <button
              type='button'
              disabled={deletingKey != null}
              className='flex items-center gap-2 text-[11px] text-gray-500 disabled:cursor-wait disabled:opacity-60'
              onClick={() => handleDeleteDinRev(row)}
              aria-label='Eliminar'
            >
              <span className='flex items-center justify-center w-9 h-9 rounded-full bg-gray-100'>
                {deletingKey === getDinRevDeleteKey(row) ? (
                  <span className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
                ) : (
                  <HighlightOffIcon sx={{ color: 'inherit', fontSize: 18 }} />
                )}
              </span>
              {deletingKey === getDinRevDeleteKey(row) ? 'Eliminando...' : 'Eliminar'}
            </button>
          )}
        </div>

        {prestamosExpandidos[row.id] && <SubTablaPrestamo row={row} onConciliar={handleClickEdit} yearFilter={yearFilter} />}
      </div>
    )
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Tipo de vinculación', field: 'folioCredito' },
    { col: 'Contraparte', field: 'razonSocial' },
    { col: 'Clasificación', field: 'nombreCuenta' },
    { col: 'Centro Costo', field: 'centroCosto' },
    { col: 'Monto', field: 'montoTotal' },
    { col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' },
    { col: 'Comentarios', field: null }
  ]

  const handleDelete = async rows => {
    if (deletingKey != null) return
    const deleteKey = getVinculoDeleteKey(rows)
    setDeletingKey(deleteKey)
    try {
      await organizationAPI.deleteRemuneracion(currentBusiness.id, rows.idPrincipal, 'vinculos')
      setData(prev => prev.filter(item => item.idPrincipal !== rows.idPrincipal))
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al eliminar:', error)
    } finally {
      setDeletingKey(null)
    }
  }

  const handleDeleteDinRev = async row => {
    if (deletingKey != null) return
    const ids = [
      ...new Set(
        (Array.isArray(row?._dinRevDocuments) ? row._dinRevDocuments : [])
          .map(getDinRevDocumentId)
          .map(Number)
          .filter(Number.isFinite)
      )
    ]

    if (!currentBusiness?.id || ids.length === 0) {
      sileo.error({
        title: 'No se pudo eliminar',
        description: 'No se encontraron movimientos adjuntos para desconciliar.'
      })
      return
    }

    const deleteKey = getDinRevDeleteKey(row)
    setDeletingKey(deleteKey)
    try {
      await organizationAPI.postDesvincular(
        { businessId: Number(currentBusiness.id), idLibro: 0 },
        { ids }
      )
      sileo.success({
        title: 'Movimiento eliminado',
        description: 'Todos los movimientos adjuntos fueron desconciliados correctamente.'
      })
      setSwitchDate(true)
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al eliminar la cuenta corriente del agente de aduana:', error)
      sileo.error({
        title: 'No se pudo eliminar',
        description: 'Ocurrió un error al desconciliar los movimientos adjuntos.'
      })
    } finally {
      setDeletingKey(null)
    }
  }

  const modalComponents = {
    PagoArriendos,
    CobroArriendos,
    GastosComunes,
    RetiroDividendo,
    PrestamoRecibido,
    AporteTransitorioSocio,
    DevolucionImpuestos,
    PagoPatenteComercial,
    PagoContribuciones,
    PrestamoOtorgado,
    CobroCuotaPrestamo,
    PagoCuotaPrestamo,
    DevolucionAporteTransitorio,
    RendicionDeGastos,
    DatosReferenciaAclarar,
    InvoiceCompra: Invoice,
    InvoiceImportaciones,
    InvoiceVenta,
    Finiquitos,
    Inversiones,
    ProvisionClientes,
    ProvisionProveedor,
    AccionesNegociables: ValoresNegociables,
    AjusteExistencia,
    VinculacionGenericaCargo,
    VinculacionGenericaAbono,
    AnticipoAgenteAduana,
    DevolucionAgenteAduana,
    AnticipoSueldo,
    ProvisionAgenteAduana,
    Multas,
    AporteEmpresaRelacionada,
    DevolucionEmpresaRelacionada
  }

  const ModalToRender = modalComponents[modalType]

  const groupByTipoYFecha = movimientos => {
    const map = {}
    movimientos.forEach(mov => {
      const tipo = normalizeMovementType(mov.tipoMovimiento)
      if (!tipo || !mov.fecha) return

      const fechaKey = new Date(mov.fecha).toISOString()
      const key = `${tipo}|${fechaKey}`

      if (!map[key]) {
        map[key] = {
          id: key,
          tipoMovimiento: tipo,
          fecha: mov.fecha,
          razonSocial: tipo === 'cargo' ? 'Pago Masivo' : 'Cobro Masivo',
          fallbackPeriodLabel: getMassivePeriodLabel(mov),
          detectedPeriods: null,
          contraparte: tipo === 'cargo'
            ? 'Proveedores varios'
            : 'Clientes varios',
          clasificacion: tipo === 'cargo' ? 'Proveedores Nacionales' : 'Clientes Ventas',
          //nClasificacion: '1-1-1-1',
          montoTotal: 0,
          status: 'CONCILIADO',
          movimientos: [],
          relatedIds: new Set()
        }
      }

      map[key].movimientos.push(mov)
      getMasivaRelatedIds(mov).forEach(id => map[key].relatedIds.add(id))

      map[key].montoTotal +=
        tipo === 'cargo'
          ? mov.montoCargo || 0
          : mov.montoAbono || 0
    })

    const usedTraceIndexes = new Set()

    return Object.values(map)
      .filter(group => group.movimientos.length > 0 && group.relatedIds.size > 0)
      .map(({ relatedIds, fallbackPeriodLabel, ...group }) => {
        const detectedPeriods = getDetectedPeriodsByGroup({
          relatedIds: [...relatedIds],
          tipoMovimiento: group.tipoMovimiento,
          fecha: group.fecha,
          montoTotal: group.montoTotal,
          usedTraceIndexes
        })

        if (!detectedPeriods && Array.isArray(massivePeriodTrace) && massivePeriodTrace.length > 0) {
          console.warn('[TableVinculaciones] No se pudo asociar massivePeriodTrace al grupo masivo', {
            tipoMovimiento: group.tipoMovimiento,
            fecha: group.fecha,
            montoTotal: group.montoTotal,
            relatedIds: [...relatedIds],
            traces: massivePeriodTrace
          })
        }

        return {
          ...group,
          detectedPeriods: detectedPeriods || fallbackPeriodLabel
        }
      })
  }

  const massiveRowsForSelectedPeriod = useMemo(() => filasMasivas.filter(row => {
    const movementDate = row?.fecha ? new Date(row.fecha) : null
    const movementYear = movementDate && !Number.isNaN(movementDate.getTime())
      ? movementDate.getUTCFullYear()
      : null
    const movementMonth = movementDate && !Number.isNaN(movementDate.getTime())
      ? movementDate.getUTCMonth() + 1
      : null
    const selectedYear = Number(yearFilter) || yearNum
    const selectedMonth = Number(monthFilter) || 0

    if (movementYear !== selectedYear) return false
    if (selectedMonth > 0 && movementMonth !== selectedMonth) return false

    return true
  }), [filasMasivas, monthFilter, yearFilter, yearNum])

  useEffect(() => {
    const availableTypes = [...new Set(
      massiveRowsForSelectedPeriod
        .map(row => MASSIVE_LINKAGE_TYPE_BY_MOVEMENT_TYPE[row.tipoMovimiento])
        .filter(Boolean)
    )]
    onMassiveTypesChange?.(availableTypes)
  }, [massiveRowsForSelectedPeriod, onMassiveTypesChange])

  const filteredFilasMasivas = useMemo(() => massiveRowsForSelectedPeriod.filter(row => {
    const tab = MASSIVE_LINKAGE_TYPE_BY_MOVEMENT_TYPE[row.tipoMovimiento]
    if (movementTab && tab !== movementTab) return false
    if (!matchesVinculacionFilters(row, searchFilters)) return false
    if (statusFilter === 'destacados' && !highlightedRows[row.id]) return false
    if (statusFilter && statusFilter !== 'destacados') {
      const matchesStatus = statusFilter === 'conciliado' ||
        (statusFilter === 'pagado' && tab === 'pago-masivo') ||
        (statusFilter === 'cobrado' && tab === 'cobro-masivo')
      if (!matchesStatus) return false
    }


    // Los cobros y pagos masivos son agrupaciones sintéticas sin centro de costo.
    if (centroCostoFilter === 'asignado') return false

    if (!linkageTypeFilter) return true

    const massiveTypeValue = MASSIVE_LINKAGE_TYPE_BY_MOVEMENT_TYPE[row.tipoMovimiento]

    if (MASSIVE_LINKAGE_TYPE_VALUES.has(linkageTypeFilter)) {
      return massiveTypeValue === linkageTypeFilter
    }

    return false
  }), [massiveRowsForSelectedPeriod, movementTab, searchFilters, statusFilter, highlightedRows, centroCostoFilter, linkageTypeFilter])

  const getRenderedSortValue = (item, field) => {
    switch (field) {
      case 'fecha': {
        const timestamp = item?.fecha ? new Date(item.fecha).getTime() : Number.NaN
        return Number.isNaN(timestamp) ? null : timestamp
      }
      case 'folioCredito':
        return item?._isDinRevVirtual
          ? 'Cuenta Corriente Agente de Aduana'
          : Number(item?.origenTabla) === 37
            ? 'Formulario 29'
            : mapFolioToModal[item?.folioCredito] || item?.razonSocial || ''
      case 'razonSocial':
        return Number(item?.origenTabla) === 37
          ? 'Servicio de Impuestos Internos'
          : item?.razonSocial || item?.contraparte || ''
      case 'nombreCuenta':
        return item?.nombreCuenta || item?.clasificacion || ''
      case 'centroCosto':
        return rowHasCentroCosto(item) ? 1 : 0
      case 'montoTotal':
        return getVinculacionMonto(item)
      case 'status':
        return getRowStatusLabel(item)
      case 'aprobado':
        return Number(item?.aprobado ?? 0)
      default:
        return item?.[field] ?? null
    }
  }

  const sortRenderedRows = rows => {
    if (!order?.field) return rows

    return [...rows].sort((left, right) => {
      const leftValue = getRenderedSortValue(left, order.field)
      const rightValue = getRenderedSortValue(right, order.field)

      if (leftValue == null && rightValue == null) return 0
      if (leftValue == null) return 1
      if (rightValue == null) return -1

      const comparison = typeof leftValue === 'number' && typeof rightValue === 'number'
        ? leftValue - rightValue
        : String(leftValue).localeCompare(String(rightValue), 'es', {
            numeric: true,
            sensitivity: 'base'
          })

      return order.direction === 'desc' ? -comparison : comparison
    })
  }

  const displayedRows = useMemo(
    () => sortRenderedRows(filteredRows.filter(item => item.origenTabla !== 37)),
    [filteredRows, order?.direction, order?.field]
  )

  const sortedMassiveRows = useMemo(
    () => sortRenderedRows(filteredFilasMasivas),
    [filteredFilasMasivas, order?.direction, order?.field]
  )

  useEffect(() => {
    onMassiveRowsChange?.(sortedMassiveRows)
  }, [sortedMassiveRows, onMassiveRowsChange])

  const displayedMassiveRows = rowsPerPage > 0
    ? sortedMassiveRows.slice(massivePage * rowsPerPage, (massivePage + 1) * rowsPerPage)
    : sortedMassiveRows

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0
  if (isMobile) {
    return (
      <div className='space-y-3 font-sans'>
        {displayedMassiveRows.map((row, i) => renderMassiveCard(row, i))}
        {displayedRows.map((row, i) => (
            <div key={row.id ?? i}>{renderRowCard(row, i)}</div>
          ))}
        {ModalToRender && <ModalToRender {...commonModalProps} action={modalAction} />}
        {openEdit && (
          <ModalConciliarVinculacion
            open={openEdit}
            setOpen={setOpenEdit}
            idLibro={dataModal.idLibro}
            cuotaPrestamo={dataModal.cuotaPrestamo}
            fVenc={dataModal.fVenc}
            folio={dataModal.folio}
            type={dataModal.type}
            status={dataModal.status}
            folioCredito={dataModal.folioCredito}
            nombreOrigen={dataModal.nombreOrigen}
            origenTabla={dataModal.origenTabla}
            setSwitchGetData={setSwitchDate}
          />
        )}
        {openComprobante && (
          <ModalViewAdministracion
            openModal={openComprobante}
            setOpenModal={setOpenComprobante}
            comprobanteId={dataComprobante.libroId}
            validation={1}
            folio={dataComprobante.nombreFolio}
            numeroFolio={dataComprobante.folio}
          />
        )}
        {openCaja && (
          <DesconciliarCaja
            open={openCaja}
            setOpen={setOpenCaja}
            rows={cajaMasiva}
            tipoMovimiento={tipoMovimientoSeleccionado}
            setSwitchGetData={setSwitchDate}
          />
        )}
        <ModalComentarios
          open={commentModal.open}
          onClose={handleCloseComments}
          onSave={handleSaveComment}
          initialValue={getCommentValue(commentModal.rowId)}
          rowId={commentModal.rowId}
        />
      </div>
    )
  }

  return (
    <div>
      <div className='h-full mt-2'>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th
                  key={i}
                  className={clsx(
                    styles.th,
                    { 'cursor-pointer': field },
                    i === 0 && styles.smallCol
                  )}
                  onClick={() => field && onSort({ col, field })}
                >
                  {col}
                  {order.col === col && (
                    <KeyboardArrowDownIcon
                      className={clsx('transition-all ml-2 cursor-pointer', {
                        'opacity-40': order.col !== col,
                        'rotate-180': order.direction === 'desc'
                      })}
                    />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayedMassiveRows.map((row, i) => (
              <tr key={`masiva-${i}`} className={styles.tr}>
                <td className={styles.td}>
                  <div className='flex items-center gap-2'>
                    {highlightedRows[row.id] ? (
                      <StarFullIcon
                        style={{ color: '#FFD700', cursor: 'pointer' }}
                        onClick={() => toggleHighlight(row.id)}
                      />
                    ) : (
                      <StarIcon
                        style={{ color: '#a1a1aa', cursor: 'pointer' }}
                        onClick={() => toggleHighlight(row.id)}
                      />
                    )}
                    {renderOriginIcon(row)}
                  </div>
                </td>
                <td className={styles.td}>
                  <Text className={styles.boldText}>{formatDate(row.fecha)}</Text>
                </td>
                <td className={styles.td}>
                  <div className='flex flex-col items-center justify-center gap-1'>
                    <Text className={styles.boldText}>{row.razonSocial}</Text>
                    <Text className='inline-flex rounded-full px-2 py-0.5 text-[0.62rem] font-semibold text-gray-500'>
                      {getDisplayPeriodLabel(row.detectedPeriods)}
                    </Text>
                  </div>
                </td>
                <td className={styles.td}>
                  <Text className={styles.boldText}>{row.contraparte}</Text>
                </td>
                <td className={styles.td}>
                  <Text className={styles.boldText}>{row.clasificacion}</Text>
                  {/*<Text className={styles.text}>{row.nClasificacion}</Text>*/}
                </td>
                <td className={styles.td}>
                  <Text className={styles.boldText}>-</Text>
                </td>
                <td className={styles.td}>
                  <Text className={styles.boldText}>{formatCurrency(getVinculacionMonto(row))}</Text>
                </td>
                <td className={styles.td}>
                  {[4, 6].includes(Number(row.folioCredito)) ? <PrestamoStatus row={row} /> : <Text className={statusBadgeClass(row.status)}>{getRowStatusLabel(row)}</Text>}
                </td>
                <td className={styles.td}>
                  <TableActionsMenu
                    onEliminar={() => handleCajaDesvincular(row)}
                    deleteDisabled={deletingKey != null}
                    deleting={deletingKey != null && deletingKey === getMassiveDeleteKey(row)}
                  />
                </td>
                <td className={styles.td}>
                  <Text className={styles.text}>-</Text>
                </td>
              </tr>
            ))}
            {displayedRows.map((row, i) => (
                <React.Fragment key={i}>
                  <tr className={clsx(styles.tr)}>
                    {/* --- Tu fila normal, igual que antes --- */}
                    <td className={styles.td}>
                      <div className='flex items-center gap-2'>
                        {highlightedRows[row.id] ? (
                          <StarFullIcon
                            style={{ color: '#FFD700', cursor: 'pointer' }}
                            onClick={() => toggleHighlight(row.id)}
                          />
                        ) : (
                          <StarIcon
                            style={{ color: '#a1a1aa', cursor: 'pointer' }}
                            onClick={() => toggleHighlight(row.id)}
                          />
                        )}

                        {renderOriginIcon(row)}
                      </div>
                    </td>
                    <td className={styles.td}>
                      <Text className={styles.boldText}>{formatDate(row.fecha)}</Text>
                    </td>
                    <td className={styles.td}>
                      <div className='flex flex-col items-center justify-center'>
                        <div className='flex items-center space-x-2'>
                          <Text className={styles.boldText}>
                            {row?._isDinRevVirtual
                              ? 'Cuenta Corriente Agente de Aduana'
                              : row.origenTabla === 37
                              ? 'Formulario 29'
                              : mapFolioToModal[row.folioCredito] || ''}
                          </Text>
                          {renderFlechaPrestamo(row)}
                        </div>
                        {!row?._isDinRevVirtual && (
                          <Text className={styles.text}>Folio <LinkageDocumentsIcon row={row} businessId={currentBusiness?.id}>{row.numeroFolio ?? '-'}</LinkageDocumentsIcon></Text>
                        )}
                      </div>
                    </td>
                    <td className={styles.td}>
                      {row?._isDinRevVirtual ? null : row.origenTabla === 37 ? (
                        <>
                          <Text className={styles.boldText}>Servicio de Impuestos Internos</Text>
                        </>
                      ) : (
                        <>
                          <Text className={styles.boldText}>{row.razonSocial}</Text>
                          <Text className={styles.text}>
                            {(row.rut && formatRut(row.rut)) || ''}
                          </Text>
                        </>
                      )}
                    </td>
                    <td className={styles.td} style={{ position: 'relative' }}>
                      {row.origenTabla !== 37 && !row?._isDinRevVirtual && (
                        <>
                          <Text className={styles.boldText}>{row.nombreCuenta}</Text>
                          <Text className={styles.text}>{row.codigoCuenta}</Text>

                       </>
                      )}
                      {!row?._isDinRevVirtual && (
                        <Text className={styles.text}>
                          {!(Number(row.folioCredito) === 6 && Number(row.comprobante) < 0) && <Link
                            onClick={() =>
                              handleComprobante(row.id, row.nombreFolio, row.folio, 'vinculos')
                            }
                            className={styles.text}
                            style={{ cursor: 'pointer' }}
                          >
                            {row.comprobante}
                          </Link>}
                          {' @' + (row.usuarioClasificador || 'TryLuca')}
                        </Text>
                      )}
                    </td>
                    <td className={styles.td}>
                      {!row?._isDinRevVirtual && renderCentroCostoBadge(rowHasCentroCosto(row))}
                    </td>
                    <td className={styles.td}>
                      <Text className={clsx(styles.boldText, 'text-center font-bold')}>
                        {formatCurrency(getVinculacionMonto(row))}
                      </Text>
                    </td>
                    <td className={styles.td}>
                      {[4, 6].includes(Number(row.folioCredito)) ? <PrestamoStatus row={row} /> : <Text className={statusBadgeClass(row.status)}>{getRowStatusLabel(row)}</Text>}
                    </td>
                    <td className={styles.td}>
                      <LinkageDocumentsIcon row={row} businessId={currentBusiness?.id} renderTrigger={({ onClick, disabled }) => (
                      <TableActionsMenu
                        onVisualizar={onClick}
                        visualizarDisabled={disabled}
                        onConciliar={Number(row.folioCredito) === 6 && !row.cuotaPrestamo
                          ? undefined : () => handleClickEdit(row)}
                        onReplicar={!row?._isDinRevVirtual && row.origenTabla !== 37 && Number(row.folioCredito) !== 35
                          ? () => handleClickOpen(row, 'replicar') : undefined}
                        onEliminar={row?._isDinRevVirtual
                          ? () => handleDeleteDinRev(row)
                          : row.origenTabla !== 37 ? () => handleDelete(row) : undefined}
                        onEditar={!row?._isDinRevVirtual && row.origenTabla !== 37
                          ? () => handleClickOpen(row, 'modificar') : undefined}
                        deleteDisabled={deletingKey != null}
                        deleting={deletingKey != null && deletingKey === (row?._isDinRevVirtual
                          ? getDinRevDeleteKey(row) : getVinculoDeleteKey(row))}
                        reconciled={row.status === 'PAGADO' || row.status === 'COBRADO'}
                      />
                      )} />
                    </td>
                    <td className={styles.td}>
                      {row?._isDinRevVirtual ? (
                        <Text className={styles.text}>-</Text>
                      ) : (
                        <div className='flex h-full items-center justify-center'>
                          {renderCommentAction({ rowId: getCommentRowId(row) })}
                        </div>
                      )}
                    </td>
                  </tr>
                  {prestamosExpandidos[row.id] && <tr><td colSpan={orderableCols.length}><SubTablaPrestamo row={row} onConciliar={handleClickEdit} yearFilter={yearFilter} /></td></tr>}
                </React.Fragment>
              ))}

            {emptyRows > 0 && (
              <tr className={styles.tr} style={{ height: 89 * emptyRows }}>
                <td className={styles.td} colSpan={orderableCols.length} aria-hidden />
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {ModalToRender && <ModalToRender {...commonModalProps} action={modalAction} />}

      {openEdit && (
        <ModalConciliarVinculacion
          open={openEdit}
          setOpen={setOpenEdit}
          idLibro={dataModal.idLibro}
          cuotaPrestamo={dataModal.cuotaPrestamo}
          fVenc={dataModal.fVenc}
          folio={dataModal.folio}
          type={dataModal.type}
          status={dataModal.status}
          folioCredito={dataModal.folioCredito}
          nombreOrigen={dataModal.nombreOrigen}
          origenTabla={dataModal.origenTabla}
          setSwitchGetData={setSwitchDate}
        />
      )}
      {openComprobante && (
        <ModalViewAdministracion
          openModal={openComprobante}
          setOpenModal={setOpenComprobante}
          comprobanteId={dataComprobante.libroId}
          validation={1} // O ajusta según lo que necesites
          folio={dataComprobante.nombreFolio}
          numeroFolio={dataComprobante.folio}
        />
      )}
      {openCaja && (
        <DesconciliarCaja
          open={openCaja}
          setOpen={setOpenCaja}
          rows={cajaMasiva}
          tipoMovimiento={tipoMovimientoSeleccionado}
          setSwitchGetData={setSwitchDate}
        />
      )}
      <ModalComentarios
        open={commentModal.open}
        onClose={handleCloseComments}
        onSave={handleSaveComment}
        initialValue={getCommentValue(commentModal.rowId)}
        rowId={commentModal.rowId}
      />
    </div>
  )
}

export default TableVinculaciones
